import { DatePipe } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, ChangeDetectionStrategy, Component, input, output, signal } from '@angular/core';
import { OpsStreamType } from '../../../models/filters.model';
import { HighAlertColumnKey } from '../../../models/high-alert-column.model';
import { HighAlert, HighAlertWindow } from '../../../models/high-alert.model';
import { HIGH_ALERT_COLUMNS } from './high-alerts-table-config';
import { BaseTableComponent } from '../../../models/base-table-component.model';
import { ZebraShadowRowsDirective } from '../../../shared/directives/zebra-shadow-rows/zebra-shadow-rows.directive';
import { AppTagComponent, TagVariant } from '../../../shared/components/app-tag/app-tag.component';

@Component({
  selector: 'dr-ops-stream-ui-high-alerts-table',
  templateUrl: './high-alerts-table.component.html',
  styleUrls: ['./high-alerts-table.component.scss'],
  imports: [ZebraShadowRowsDirective, DatePipe, AppTagComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HighAlertsTableComponent extends BaseTableComponent<HighAlert, HighAlertColumnKey> {
  readonly opsStreamType = OpsStreamType;
  isCurrentStatus = input.required<boolean>();
  viewAlert = output<HighAlert>();
  editAlert = output<HighAlert>();

  readonly tagVariants: Record<HighAlertWindow, TagVariant> = {
    [HighAlertWindow.HIGH_ALERT]: TagVariant.HighAlert,
    [HighAlertWindow.ELEVATED]: TagVariant.Elevated,
    [HighAlertWindow.AUDIT]: TagVariant.Audit,
    [HighAlertWindow.HOT_WEATHER]: TagVariant.HotWeather,
    [HighAlertWindow.COLD_WEATHER]: TagVariant.ColdWeather,
  };

  constructor() {
    super(signal(HIGH_ALERT_COLUMNS));
  }

  protected onView(alert: HighAlert) {
    this.viewAlert.emit(alert);
  }

  protected onEdit(alert: HighAlert) {
    this.editAlert.emit(alert);
  }

  getTagVariant(window: HighAlertWindow): TagVariant {
    return this.tagVariants[window] ?? TagVariant.Info;
  }
}
